import React, { forwardRef } from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { echarts } from './chartCore';

// Drop-in for `echarts-for-react`'s default export, bound to the tree-shaken core in chartCore.js.
const Chart = forwardRef(function Chart(props, ref) {
  return <ReactEChartsCore ref={ref} echarts={echarts} {...props} />;
});

export default Chart;
